import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAsciiOnly]',
})
export class AsciiOnlyDirective {
  // Regex to allow only ASCII characters (0-127 range)
  private regex: RegExp = /^[\x00-\x7F]+$/;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    let inputValue: string = this.el.nativeElement.value;
    const value = inputValue?.trimStart();
    // Remove non-ASCII characters (allow only ASCII including space)
    let sanitizedValue = value?.replace(/[^\x00-\x7F]/g, '');

    // Remove leading spaces but allow spaces after first character
    sanitizedValue = sanitizedValue?.replace(/^\s+/, '');

    if (inputValue !== sanitizedValue) {
      this.el.nativeElement.value = sanitizedValue;
      event.preventDefault();
    }
  }
}
